import { Injectable, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService, LoggerService } from '@adreno-common';
import { PortalMenuComponent } from '../components';
import { TeleworkerState } from '../models';
import { distinctUntilChanged, filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private campaignIdSub = new BehaviorSubject<number | undefined>(undefined);
  private customDataSub = new BehaviorSubject<string | undefined>(undefined);
  private queueIdSub = new BehaviorSubject<number | undefined>(undefined);
  private recordIdSub = new BehaviorSubject<number | undefined>(undefined);
  private scriptVersionSub = new BehaviorSubject<number | undefined>(undefined);
  private sidebarMenuSub = new BehaviorSubject<Type<any>>(PortalMenuComponent);
  private stateSub = new BehaviorSubject<TeleworkerState | undefined>(
    undefined
  );

  campaignId$ = this.campaignIdSub.asObservable();
  public set campaignId(v: number | undefined) {
    this.campaignIdSub.next(v);
  }

  customData$ = this.customDataSub.asObservable();
  public set customData(v: string | undefined) {
    this.customDataSub.next(v);
  }

  queueId$ = this.queueIdSub.asObservable();
  public set queueId(v: number | undefined) {
    this.queueIdSub.next(v);
  }

  recordId$ = this.recordIdSub.asObservable();
  public set recordId(v: number | undefined) {
    this.recordIdSub.next(v);
  }

  scriptVersion$ = this.scriptVersionSub.asObservable();
  public set scriptVersion(v: number | undefined) {
    this.scriptVersionSub.next(v);
  }

  sidebarMenu$ = this.sidebarMenuSub.asObservable();
  public set sidebarMenu(v: Type<any> | undefined) {
    this.logger.debug('CoreService', `sidebarMenu ${v?.name || 'undefined'}`)();
    this.sidebarMenuSub.next(v || PortalMenuComponent);
  }

  state$ = this.stateSub.asObservable();
  public set state(v: TeleworkerState) {
    this.stateSub.next(v);
  }

  constructor(private logger: LoggerService, private authSvc: AuthService) {
    /*
    this.authSvc.isLoggedIn$
      .pipe(
        filter((loggedIn) => !!loggedIn),
        take(1)
      )
      .subscribe((loggedin) => {
        if (loggedin) this.state = TeleworkerState.Login;
      });
    */
  }
}
